import { getToken } from './tokenHelper';

export default {
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  checkAuth: () => (getToken() ? Promise.resolve() : Promise.reject()),
  checkError: () => Promise.resolve(),
  getPermissions: () => Promise.resolve(JSON.parse(localStorage.getItem('authorization'))),
};
